import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const ScheduleTrainingSection = () => {

  return (
    <section className="w-full bg-white py-16 md:py-24 overflow-hidden font-inter relative">
      {/* Elementos Decorativos de Fundo */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[15%] right-[-10%] w-[600px] h-[600px] bg-purple-100/30 rounded-full blur-[140px]" />
        <div className="absolute bottom-[20%] left-[-10%] w-[500px] h-[500px] bg-indigo-50/40 rounded-full blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 md:gap-24 items-center">
          
          {/* Lado Esquerdo: Conteúdo Estratégico */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col gap-8"
          >
            <div className="flex flex-col gap-6">
              <div className="inline-flex items-center gap-3 bg-purple-50 px-5 py-2 rounded-full w-fit border border-purple-100/50">
                <div className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-purple-600"></span>
                </div>
                <span className="text-[#7f00ff] font-extrabold text-[12px] uppercase tracking-[0.25em]">Implementação e Sucesso</span>
              </div>
              
              <h2 className="text-[42px] md:text-[64px] font-extrabold text-[#0f172a] leading-[0.95] tracking-[-0.06em] font-outfit">
                Aceleração <br />
                <span className="text-[#7f00ff] relative inline-block">
                  exclusiva
                  <svg className="absolute -bottom-2 left-0 w-full h-3 text-purple-200 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none">
                    <path d="M0 5 Q 25 0, 50 5 T 100 5" fill="none" stroke="currentColor" strokeWidth="8" />
                  </svg>
                </span> <br />
                para clientes Lukos
              </h2>
            </div>

            <p className="text-[18px] md:text-[20px] text-slate-500 leading-relaxed max-w-xl font-medium">
              Acelere sua operação com a metodologia oficial da Lukos. Implementação prática e estratégica desenhada para extrair a máxima performance de cada módulo do sistema.
            </p>

            {/* Lista de Diferenciais Estilizada */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
              {[
                { label: "Mestria Operacional", desc: "Domínio total das funções do ERP" },
                { label: "Check-out Ágil", desc: "Alta performance na frente de caixa" },
                { label: "Gestão Inteligente", desc: "Controle de estoque e inventário" },
                { label: "Apoio Estratégico", desc: "Consultoria focada em resultados" }
              ].map((item, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 * index }}
                  className="flex gap-4 group items-start"
                >
                  <div className="w-10 h-10 shrink-0 rounded-xl bg-white border border-purple-100 shadow-sm flex items-center justify-center text-[#7f00ff] group-hover:bg-[#7f00ff] group-hover:text-white transition-all duration-300">
                    <CheckCircle2 size={20} strokeWidth={2.5} />
                  </div>
                  <div>
                    <h4 className="font-extrabold text-[#0f172a] text-[15px] mb-0.5">{item.label}</h4>
                    <p className="text-slate-400 text-[12px] font-semibold leading-tight">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>

          </motion.div>

          {/* Lado Direito: FormulÃ¡rio de Agendamento Moderno */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="relative w-full max-w-[540px] ml-auto"
          >
             {/* Container da Imagem com EstÃ©tica Premium */}
             <div className="relative rounded-[48px] overflow-hidden shadow-[0_50px_100px_-20px_rgba(0,0,0,0.15)] border-8 border-white group">
                <img 
                  src="/assets/training/meet_session.png" 
                  alt="Implementação Técnica Lukos" 
                  className="w-full h-full object-cover aspect-[4/5] scale-105 group-hover:scale-100 transition-transform duration-1000"
                />
                
                {/* Overlay Gradiente */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#7f00ff]/40 to-transparent opacity-60" />


                {/* Elemento de Brilho */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/20 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" />
             </div>

             {/* Elemento Decorativo Externo */}
             <div className="absolute -z-10 -bottom-6 -right-6 w-32 h-32 bg-purple-100 rounded-full blur-2xl opacity-50" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleTrainingSection;
